import React, { SyntheticEvent, useMemo, useCallback } from 'react';
import { PMCConfig } from '@kyruus/types';
import {
  Log,
  ExtendedProvider,
  FullAppointmentInfo,
  SearchSummary
} from 'Src/types';
import { BookOnline, VirtualCare, Phone, RequestForm } from './CtaListItems';
import { List } from '../styles';
import { DefaultCtaListItems, getCtaListItemsToDisplay } from '../lib';

interface BaseCtaListProps {
  onClose: (
    e: SyntheticEvent,
    reason?: 'closeIcon' | 'escapeKeyDown' | 'backdropClick'
  ) => void;
  provider: ExtendedProvider;
  config: PMCConfig;
  searchSummary?: SearchSummary;
  apptOptions?: FullAppointmentInfo;
  log: Log;
}

type CtaListProps = BaseCtaListProps;

export const CtaList = ({
  provider,
  config,
  searchSummary,
  apptOptions = {},
  log
}: CtaListProps) => {
  const ctaListItems = useMemo(
    () => getCtaListItemsToDisplay(config, provider),
    [config, provider]
  );
  const trackListItemClick = useCallback(
    (listItem: DefaultCtaListItems) => {
      log(`user_action.alter_view.request_appointment.${listItem}`, {
        provider_id: provider.id
      });
    },
    [log, provider.id]
  );
  function renderListItem(listItemId: DefaultCtaListItems) {
    switch (listItemId) {
      case DefaultCtaListItems.BookOnline:
        return (
          <BookOnline
            key={listItemId}
            provider={provider}
            config={config}
            apptOptions={apptOptions}
            searchSummary={searchSummary}
            trackListItemClick={trackListItemClick}
          />
        );
      case DefaultCtaListItems.Phone:
        return (
          <Phone
            key={listItemId}
            provider={provider}
            trackListItemClick={trackListItemClick}
          />
        );
      case DefaultCtaListItems.RequestForm:
        return (
          <RequestForm
            key={listItemId}
            provider={provider}
            trackListItemClick={trackListItemClick}
          />
        );
      case DefaultCtaListItems.VirtualCare:
        return (
          <VirtualCare
            key={listItemId}
            provider={provider}
            trackListItemClick={trackListItemClick}
          />
        );
      default:
        return null;
    }
  }
  return (
    <List disablePadding={true}>
      {ctaListItems.map((item) => {
        return renderListItem(item);
      })}
    </List>
  );
};
